import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function getMyEarnings(token, api_token, from_date, to_date,page = 1) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/earningslist?api_token=${api_token}&from_date=${from_date}&to_date=${to_date}&page=${page}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_MY_EARNINGS_REQUEST, types.GET_MY_EARNINGS_RECEIVE, {
                type: types.GET_MY_EARNINGS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetEarnings = () => ({
    type: types.RESET_GET_MY_EARNINGS,
    payload: null
});